
import { cn } from "@/lib/utils";

interface StatBarProps {
  name: string;
  value: number;
  maxValue?: number;
  className?: string;
  compact?: boolean;
}

const StatBar = ({ name, value, maxValue = 150, className, compact = false }: StatBarProps) => {
  // Abbreviate stat names
  const getStatAbbreviation = (statName: string) => {
    switch (statName) {
      case "hp": return "HP";
      case "attack": return "ATK";
      case "defense": return "DEF";
      case "special-attack": return "SP.ATK";
      case "special-defense": return "SP.DEF";
      case "speed": return "SPD";
      default: return statName.toUpperCase();
    }
  };

  // Determine color based on stat value
  const getStatColor = (value: number) => {
    if (value >= 100) return "bg-green-500";
    if (value >= 70) return "bg-emerald-400";
    if (value >= 50) return "bg-yellow-500";
    return "bg-red-500";
  };

  const percentage = Math.min(Math.max((value / maxValue) * 100, 5), 100);

  return (
    <div className={cn("flex items-center text-sm mb-2", compact && "mb-1.5 text-[13px]", className)}>
      <span className={cn("w-16 font-medium text-gray-700", compact && "w-12 text-[11px]")}>
        {getStatAbbreviation(name)}
      </span>
      <div className={cn("flex-1 h-4 bg-gray-200 rounded-full overflow-hidden", compact && "h-2.5")}>
        <div 
          className={`h-full rounded-full ${getStatColor(value)}`} 
          style={{ width: `${percentage}%` }}
        />
      </div>
      <span className={cn("w-8 text-right ml-2 font-bold", compact && "w-7 ml-1.5 text-[11px]")}>
        {value}
      </span>
    </div>
  );
};

export default StatBar;
